import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Autocomplete, Chip } from '@mui/material'
import { TextField } from "@material-ui/core"
import axios from 'axios'

export default function CoafClauseNumberList(props) {
    const { t } = useTranslation()
    const { value = [], onChange, readOnly, regulatoryAuthority = 'bacen' } = props

    const [ clauseNumberOptions, setClauseNumberOptions ] = useState([])
    const [ areClausesLoading, setAreClausesLoading ] = useState(false)

    const toSafeString = (value) => {
        if (value === null || value === undefined) return ""
        if (typeof value === "string") return value
        if (typeof value === "number" || typeof value === "boolean") return String(value)
        if (typeof value === "object" && typeof value.toString === "function") {
            const str = value.toString()
            return str === "[object Object]" ? "" : str
        }
        return ""
    }

    const formatOptionLabel = (option) => {
        const description = toSafeString(option?.description)
        const clauseNumber = toSafeString(option?.clause_number)
        if (!clauseNumber && !description) return ""
        return description ? `${clauseNumber} - ${description}` : `${clauseNumber}`
    }

    const formatChipLabel = (option) => {
        const description = toSafeString(option?.description)
        const clauseNumber = toSafeString(option?.clause_number)
        const truncatedDescription = description.slice(0, 30)
        const chipDescription = description.length > 30 ? `${truncatedDescription}...` : truncatedDescription
        if (!clauseNumber && !chipDescription) return ""
        return chipDescription ? `${clauseNumber} - ${chipDescription}` : `${clauseNumber}`
    }

    const doRequest = async () => {
        setAreClausesLoading(true)
        try {
            const response = await axios.get('/dash/alerts/coaf_clauses', {
                params: { regulatory_authority: regulatoryAuthority }
            })
            setClauseNumberOptions(Array.isArray(response.data.clauses) ? response.data.clauses : [])
        } catch (error) {
            console.error("Failed to fetch clause numbers:", error)
        } finally {
            setAreClausesLoading(false)
        }
    }

    useEffect(() => {
        doRequest()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [regulatoryAuthority])

    const selectedValues = (value || []).map(valId => {
        return clauseNumberOptions.find(opt => opt.clause_number === valId) || { clause_number: valId, description: valId }
    })

    const ChipProps = {
        sx: {
            bgcolor: '#0b1f8288',
            color: 'white',
            fontWeight: 'bold',
            '& .MuiChip-deleteIcon': {
                color: '#ffffffb2',
                display: readOnly ? 'none' : 'block'
            },
            '&:hover .MuiChip-deleteIcon': { color: '#ffffff' }
        }
    }

    return (
        <Autocomplete
            multiple
            fullWidth
            disableCloseOnSelect

            readOnly={readOnly}
            disableClearable={readOnly}
            popupIcon={readOnly ? null : undefined}

            options={clauseNumberOptions}
            value={selectedValues}

            getOptionLabel={formatOptionLabel}

            isOptionEqualToValue={(option, val) => option.clause_number === val.clause_number}

            onChange={(event, newValue) => {
                if (onChange) {
                    const stringValues = newValue.map(item => item.clause_number)
                    onChange(stringValues)
                }
            }}

            disabled={areClausesLoading}

            ChipProps={ChipProps}
            renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                    <Chip
                        {...getTagProps({ index })}
                        {...ChipProps}
                        label={formatChipLabel(option)}
                    />
                ))
            }
            style={{ marginTop: "8px" }}

            renderInput={(params) => (
                <TextField
                    {...params}
                    fullWidth
                    label={t("Enquadramentos")}
                    placeholder={areClausesLoading ? t("Carregando...") : undefined}
                    className="filterTextbox"
                    style={{ textAlign: "center" }}
                    InputProps={{
                        ...params.InputProps,
                        readOnly: readOnly,
                    }}
                />
            )}
        />
    )
}